import { useAuthTokenQuery } from '../queries';

export function useGetAuthToken() {
    const { data } = useAuthTokenQuery();

    return data || { auth: localStorage.getItem('auth') === 'true', token: localStorage.getItem('token') };
}
